import Component from 'vue-class-component'

import { Container, ContainerStatus } from '@skinsoft/types'
import { ContainerDataStore } from '@skinsoft/entity'
import { containerSelectors } from '@skinsoft/entity-ui'
import { ReactiveVue } from '@skinsoft/reactive-vue'
import { AddContainerModal, StateInput } from '@skinsoft/ui'

@Component({
    components: {
        sStateInput: StateInput,
        sContainerModal: AddContainerModal,
    },
    props: {
        statusesToSearch: {
            type: Array,
            required: false,
        },
        excludedIds: Array,
    },
    template: require('./container-input.html'),
})
export default class ContainerInput extends ReactiveVue {
    private statusesToSearch: ContainerStatus[] | undefined

    public selectedContainer: Container
    public $containerDatastore: ContainerDataStore

    public containerStatus: ContainerStatus[]

    public $refs: {
        containerModal: AddContainerModal
        stateInput: StateInput
    }

    public created() {
        this.$containerDatastore = ContainerDataStore.getInstance()
    }

    public openPopup() {
        this.$refs.containerModal.open()
    }

    public onContainerSelected(container: {id: string, type: string}) {
        this.$containerDatastore.fetchOne(container.id).subscribe(container => {
            this.selectedContainer = container
            this.$refs.stateInput.setValue(containerSelectors.identifier(this.selectedContainer) || containerSelectors.title(this.selectedContainer))
        })
        
        this.$emit('change', container)
    }
}
